const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const DEBUG_MODE = process.env.REACT_APP_ANALYTICS_DEBUG === 'true';

export const initGA = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_title: document.title,
      page_location: window.location.href,
      debug_mode: DEBUG_MODE,
    });
  }
};

export const trackPageView = (pageTitle, pagePath) => {
  if (typeof window !== 'undefined' && window.gtag) {
    const pageData = {
      page_title: pageTitle,
      page_location: window.location.origin + pagePath,
      page_path: pagePath,
      debug_mode: DEBUG_MODE,
    };

    window.gtag('config', GA_MEASUREMENT_ID, pageData);
  }
};

export const trackEvent = (eventName, parameters = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    const eventData = {
      ...parameters,
      debug_mode: DEBUG_MODE,
    };

    window.gtag('event', eventName, eventData);
  }
};

export const trackHangmanGameStart = (category = 'all') => {
  trackEvent('hangman_game_start', {
    event_category: 'hangman',
    event_label: category,
    category: category,
  });
};

export const trackHangmanGameEnd = (
  result,
  category = 'all',
  wrongGuesses = 0
) => {
  trackEvent('hangman_game_end', {
    event_category: 'hangman',
    event_label: result,
    result: result,
    category: category,
    wrong_guesses: wrongGuesses,
  });
};

export const trackHangmanCategoryChange = category => {
  trackEvent('hangman_category_change', {
    event_category: 'hangman',
    event_label: category,
    category: category,
  });
};

export { GA_MEASUREMENT_ID };
